const VTV_SOURCE = 'https://abhchand.me/vanilla-tree-viewer/';
const UTM_CAMPAIGN = 'usage';

export { VTV_SOURCE, UTM_CAMPAIGN };
